/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meta_List_Status_NoneInputs */



/**
* | output |
* | --- |
* | "No list" |
*
* @param {Meta_List_Status_NoneInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const meta_list_status_none = /** @type {((inputs?: Meta_List_Status_NoneInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meta_List_Status_NoneInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Keine Liste")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucune liste")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("无卡组表")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("沒有牌組清單")
	if (locale === "ko") return /** @type {LocalizedString} */ ("리스트 없음")
	return /** @type {LocalizedString} */ ("No list")
});